<template>
    <main class="CercaView-MAIN DISPLAY">
    <main class="INNER-MARGIN">

        <h3>Promociones cerca de ti</h3>
        <img src="../assets/promociones-cerca-de-ti.png"/>

        <h2>Encuentra las mejores ofertas más cerca de ti</h2>
        <br/>
        <img src="../assets/encuentra-donde-puedes.png" class="encuentra-donde-puedes"/>

        <!--<img src="../assets/examples/map-example.png"/>-->

        <section class="map-wrapper">
            <div class="map-left-column">
                <div class="map-controls">
                    <label for="business-select">
                        Buscar promociones de:
                    </label>

                    <select
                        id="business-select"
                        v-model="selectedBusiness"
                        :disabled="loading || !businessOptions.length"
                    >
                        <option value="" disabled>
                            Selecciona una tienda
                        </option>

                        <option
                            v-for="business in businessOptions"
                            :key="business"
                            :value="business"
                        >
                            {{ business }}
                        </option>
                    </select>
                </div>

                <p v-if="loadingCupones">
                    Cargando cupones...
                </p>

                <div
                    class="map-cupones"
                    v-if="!loadingCupones"
                >
                    <a
                        v-for="item in filteredSelectedCoupons.slice(0, 3)"
                        :key="item.id"
                        :href="`${getFrontURL()}/cupon/?cupon=${item.id}`"
                    >
                        <img
                            :src="item.url_banner"
                            @error="onBannerError"
                        >
                    </a>
                </div>
            </div>

            <ViewMapByName
                v-if="!loading && selectedBusiness"
                :search-term="selectedBusiness"
                :api-key="apiKey"
                :radius="10_000"
            />

            <img
                v-else-if="!loading"
                src="../assets/mapa-base.png"
                class="map-base"
                alt="Selecciona una tienda para buscar promociones"
            />
        </section>

        <br/>
        <br/>

    </main>
    </main>
</template>

<script>
import ViewMapByName from "./ViewMapByName.vue";

export default {
    name: "CercaView",

    components: {
        ViewMapByName
    },

    data() {
        return {
            apiKey: "AIzaSyBWYjaZoteGTAD_Ujgi1BK1T9A3DmXqGk4",

            cupones: [],

            selectedBusiness: "",

            loading: true,
            loadingCupones: true,
        };
    },

    computed: {
        businessOptions() {
            return [
                ...new Set(
                    this.cupones
                        .map(item => {
                            return String(
                                item.marca_grupo ||
                                item.nombre ||
                                ""
                            ).trim();
                        })
                        .filter(Boolean)
                )
            ].sort((a, b) => {
                return a.localeCompare(b, "es");
            });
        },

        filteredSelectedCoupons() {
            if (!this.selectedBusiness) {
                return [];
            }

            const selected = this.normalizeName(
                this.selectedBusiness
            );

            return this.cupones.filter(item => {
                const business = this.normalizeName(
                    item.marca_grupo ||
                    item.nombre ||
                    ""
                );

                return business === selected;
            });
        }
    },

    methods: {
        async getCupones() {
            this.loading = true;
            this.loadingCupones = true;

            try {
                const response = await fetch(
                    "https://promo-colaboradores.ideeo.mx/api/cupones",
                    {
                        method: "POST",
                        headers: {
                            "Content-Type": "application/json"
                        },
                        body: JSON.stringify({
                            id: "1",
                            tipo_cupon: "1",
                        })
                    }
                );

                if (!response.ok) {
                    throw new Error(
                        `HTTP ${response.status}`
                    );
                }

                const result = await response.json();

                /*
                 * Ya no filtramos por coordenadas.
                 * Solo conservamos cupones que tengan
                 * nombre o marca para buscar.
                 */
                this.cupones = (result.data || []).filter(
                    item => {
                        return Boolean(
                            String(
                                item.marca_grupo ||
                                item.nombre ||
                                ""
                            ).trim()
                        );
                    }
                );

            } catch (error) {
                console.error(
                    "Error obteniendo cupones:",
                    error
                );

                this.cupones = [];
            } finally {
                this.loading = false;
                this.loadingCupones = false;
            }
        },

        normalizeName(value) {
            return String(value || "")
                .toLowerCase()
                .trim()
                .normalize("NFD")
                .replace(/[\u0300-\u036f]/g, "")
                .replace(/[^a-z0-9\s]/g, " ")
                .replace(/\s+/g, " ")
                .trim();
        },

        getFrontURL() {
            return window.location.origin;
        },

        onBannerError(event) {
            event.target.onerror = null;
            event.target.src =
                "https://promo-colaboradores.ideeo.mx/cupones/NULL%20BANNER.png";
        }
    },

    mounted() {
        this.getCupones();
    }
};
</script>

<style scoped lang="stylus">
.CercaView-MAIN{
    font-family: 'Benton Sans BBVA book';
    background-color: #9e97f863;
    min-height: calc(100vh - 40px);
}

.INNER-MARGIN{
    display: flex;
    flex-direction: column;
    align-items: center;
}

.INNER-MARGIN > img:not(.encuentra-donde-puedes){
    width: 100%;
    margin-bottom: 1ch;
}

h3, section > p, .INNER-MARGIN > p{
    width: 100%;
    text-align: center;
}

h3{
    font-weight: 200;
    color: white;
    background-color: #051283;
    width: fit-content;
    margin-left: auto;
    margin-right: auto;
    padding: 0 1ch;
}

h2{
    font-family: 'Benton Sans BBVA bold';
    color: #051283;
    margin-bottom: 0.3ch;
}

.encuentra-donde-puedes{
    width: auto;
    height: 3.1ch;
    margin-bottom: 3.5ch;
}

.map-wrapper
    display: flex
    align-items: center
    width: 100%
    height: 300px

    >p
        width: fit-content
        padding: 0 1ch
        white-space: nowrap

    >.map-cupones
        display: flex
        flex-direction: column
        padding: 10px

        img
            height: 90px

.map-wrapper
    display: flex
    align-items: flex-start
    width: 100%
    min-height: 300px
    height: auto
    gap: 20px

.map-left-column
    display: flex
    flex-direction: column
    gap: 15px
    min-width: 250px
    max-width: 350px

.map-controls
    display: flex
    flex-direction: column
    gap: 8px
    padding: 0

    select
        width: 100%
        padding: 8px
        border: 1px solid lightgray
        border-radius: 5px
        background-color: white

.map-cupones
    display: flex
    flex-direction: column
    gap: 10px

    a
        display: flex

    img
        width: 100%
        height: auto

/* RESPONSIVE */
@media all and (max-width:780px)

    .CercaView-MAIN
        min-height: calc(100vh - 40px + 300px)

    h2
    h3
    p
        text-align: center

    .map-wrapper
        flex-direction: column
        
        >.map-cupones
            align-items: center
            justify-content: center
            width: 100%

            >a
                display: flex
                align-items: center
                justify-content: center
                margin-bottom: 10px

            img
                width: 80%
                height: auto

@media all and (max-width:780px)
    .map-wrapper
        flex-direction: column

    .map-left-column
        width: 100%
        min-width: 0
        max-width: none

    .map-controls
        width: 100%

    .map-cupones
        width: 100%
</style>
